import { apiErrorMessage } from "@/services/apiErrorMessage";

export interface PortalAccess {
  portal_role?: string;
  tenant_roles: string[];
  can_access_cms: boolean;
  can_access_library: boolean;
}

export function readPortalAccess(payload: any): PortalAccess {
  const data = payload.data ?? payload;
  const user = data.user ?? payload.user ?? {};
  const roles = data.tenant_roles ?? user.tenant_roles;
  return {
    portal_role: data.role ?? user.role,
    tenant_roles: Array.isArray(roles) ? roles : [],
    can_access_cms: (data.can_access_cms ?? user.can_access_cms) === true,
    can_access_library:
      (data.can_access_library ?? user.can_access_library) === true,
  };
}

export function canManagePortalUsers(access: PortalAccess | null): boolean {
  return (
    !!access &&
    (access.portal_role === "admin" ||
      access.tenant_roles.some(role =>
        ["admin", "jambushrusti_admin"].includes(role.toLowerCase())
      ))
  );
}

export async function signupJambushrusti(
  email: string,
  password: string,
  role: "cms" | "library" | "admin"
): Promise<void> {
  const base = import.meta.env.DEV
    ? "/jambushrusti-api"
    : (
        import.meta.env.VITE_API_BASE_URL ??
        "https://api.jambushusti.universal-software.in/api"
      ).replace(/\/$/, "");
  const response = await fetch(`${base}/jambushrusti/auth/signup/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Tenant-Id":
        import.meta.env.VITE_X_TENANTID ??
        "6cf833d7-bf6f-4688-9136-5674d8053b85",
    },
    body: JSON.stringify({ email: email.trim(), password, role }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(
      apiErrorMessage(
        payload,
        "Unable to create your account. Please try again."
      )
    );
  }
}
